<div class="vault-page-shell">
  <div class="mx-auto max-w-3xl">
    <section class="vault-panel p-6 sm:p-8">
      <div class="space-y-6">
        <div class="border-b border-slate-200 pb-5">
          <h1 class="az-logo text-3xl">fasten</h1>
        </div>

        <ng-container *ngIf="status === 'processing'; else callbackError">
          <div class="space-y-2 text-center">
            <h2 class="vault-page-title">Finishing sign-in</h2>
          </div>

          <div class="flex justify-center">
            <app-spinner [sizePx]="32" [strokeWidthPx]="3"></app-spinner>
          </div>
        </ng-container>

        <ng-template #callbackError>
          <div class="flex items-start gap-4">
            <div class="auth-callback-error-icon" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" class="block h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 8v4"></path>
                <path d="M12 16h.01"></path>
              </svg>
            </div>
            <div class="min-w-0 space-y-2">
              <p class="vault-page-kicker text-red-600">Sign-in error</p>
              <h2 class="vault-page-title">We could not complete sign-in</h2>
            </div>
          </div>

          <div class="auth-callback-error-details">
            <h3 class="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Error details</h3>
            <dl class="mt-4 divide-y divide-slate-200 text-sm">
              <div class="grid gap-1 py-3 sm:grid-cols-[9rem_1fr] sm:gap-4">
                <dt class="font-medium text-slate-500">Error type</dt>
                <dd class="min-w-0 break-words font-medium text-slate-900">{{error}}</dd>
              </div>
              <div class="grid gap-1 py-3 sm:grid-cols-[9rem_1fr] sm:gap-4">
                <dt class="font-medium text-slate-500">Description</dt>
                <dd class="min-w-0 break-words text-slate-900">{{errorDescription}}</dd>
              </div>
              <div *ngIf="errorUri" class="grid gap-1 py-3 sm:grid-cols-[9rem_1fr] sm:gap-4">
                <dt class="font-medium text-slate-500">More info</dt>
                <dd class="min-w-0 break-words">
                  <a [href]="errorUri" class="font-medium text-[#5B47FB] hover:text-[#4936E8]">{{errorUri}}</a>
                </dd>
              </div>
            </dl>
          </div>

          <div class="flex justify-end border-t border-slate-200 pt-5">
            <button [routerLink]="'/auth/signin'" type="button" class="vault-primary-button px-4 py-3">
              Back to Sign In
            </button>
          </div>
        </ng-template>
      </div>
    </section>
  </div>
</div>
